import { useMemo } from 'react';
import { isNewCommentsDesign } from '../helpers/featureFlags';

export const useNewCommentsDesign = (): boolean => useMemo(() => isNewCommentsDesign(), []);

export default useNewCommentsDesign;
